import ProducerPlans from './ProducerPlans';

import { RouteObject } from 'react-router-dom';

export const ProducerPlansRoutes: RouteObject[] = [
  {
    path: 'affiliate/producer-plans/:npn',
    element: <ProducerPlans />,
  },
];
